export class SeededRNG {
  private seed: number;

  constructor(seed: number) {
    this.seed = seed >>> 0;
  }

  next(): number {
    this.seed = (this.seed * 1103515245 + 12345) & 0x7fffffff;
    return this.seed / 0x7fffffff;
  }

  nextInt(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  nextFloat(min: number, max: number): number {
    return this.next() * (max - min) + min;
  }

  pick<T>(array: T[]): T {
    return array[Math.floor(this.next() * array.length)];
  }

  shuffle<T>(array: T[]): T[] {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(this.next() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  }

  getSeed(): number {
    return this.seed;
  }
}

let gameRNG: SeededRNG = new SeededRNG(Date.now());

export function setGameSeed(seed: number): void {
  gameRNG = new SeededRNG(seed);
}

export function getGameRNG(): SeededRNG {
  return gameRNG;
}

/**
 * Run fn with the given RNG installed as the active game RNG, restoring the
 * previous one afterwards. Simulation instances own their RNG and wrap each
 * tick with this, so multiple rooms in one server process stay deterministic.
 * Safe because simulation ticks are fully synchronous.
 */
export function withRNG<T>(rng: SeededRNG, fn: () => T): T {
  const previous = gameRNG;
  gameRNG = rng;
  try {
    return fn();
  } finally {
    gameRNG = previous;
  }
}

export function generateRandomSeed(): number {
  return Math.floor(Math.random() * 0x7fffffff);
}
